import { OnInit, ViewChild, Component } from '@angular/core';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { SearchFilterComponent } from '../../../search-filter/search-filter.component';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';
import { MenuService } from '../../../../services/menu.service';
import { CashDeskService } from '../../../../services/cash-desk.service';
import { SearchFilter, IFilterResponse } from '../../../../infrastructure/iFilter-component';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { CashDeskOpenSearchItem } from '../../../../model/cash-desk-open-search-item';
import { PagerControlComponent } from '../../../controls/pager/pager-control.component';
import { ConfirmDialogService } from '../../../../services/confirm-dialog.service';
import { PdfService } from '../../../../services/pdf.service';
import { DownloadLocalFileService } from 'src/app/services/download-local-file.service';

@Component({
  selector: 'app-cash-desk-open-search',
  templateUrl: './cash-desk-open-search.component.html',
  styleUrls: ['./cash-desk-open-search.component.css']
})
export class CashDeskOpenSearchComponent implements OnInit {

  loading: boolean;
  cashDeskOpenSearchItems: CashDeskOpenSearchItem[] = [];
  searchFilters: SearchFilter[];
  displayedColumns: string[] = ['CashDeskName', 'OpenDateTimeView', 'UserName', 'Star'];
  dataSource = new MatTableDataSource([]);
  @ViewChild('searchFilter', {static: false}) searchFilter: SearchFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;

  constructor(public dialog: MatDialog,
    private router: Router,
    private cashDeskService: CashDeskService,
    private menuService: MenuService,
    private confirmDialogService: ConfirmDialogService,
    private pdfService: PdfService,
    private downloadLocalFileService: DownloadLocalFileService,
    private notificationToastService: NotificationToastService) {
      this.menuService.setMenuTitle('Caja', 'Apertura y cierre');
  }

  ngOnInit(): void {

  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }


  onEndSearch(response: IFilterResponse<CashDeskOpenSearchItem>) {
    this.cashDeskOpenSearchItems = response.items;
    this.searchFilters = response.searchFilters;
    this.pager.setItems(this.cashDeskOpenSearchItems);
  }

  onStartSearch() {
    this.loading = true;
  }

  cashDeskOpenEditRedirect(item: CashDeskOpenSearchItem): void {
    this.router.navigate(['cash-desk-open-edit', item.CashDeskId]);
  }

  canOpen(cashDeskOpenSearchItem: CashDeskOpenSearchItem): boolean {
    return !cashDeskOpenSearchItem.CashDeskOpenId;
  }

  cashDeskOpenClose(cashDeskOpenSearchItem: CashDeskOpenSearchItem) {
    this.confirmDialogService.confirm('Cierre de caja',
      'Esta seguro que desea cerrar la caja', 'Si', 'No').subscribe(async (value) => {
        try {
          if ( value )  {
            this.loading = true;
            if (cashDeskOpenSearchItem.CashDeskOpenId) {
              await this.cashDeskService.cashDeskOpenClose(cashDeskOpenSearchItem);
              this.confirmDialogService.confirm('Cierre de caja',
              `El numero de cierre es ${cashDeskOpenSearchItem.CashDeskOpenId}. Desea realizar la exportación del cierre?`,
               'Si', 'No').subscribe(async (valueExport) => {
                 if (valueExport) {
                    this.printCashDeskOpenCloseReport(cashDeskOpenSearchItem);
                 }
                 await this.searchFilter.search();
              });
            }
          }
        } catch (err) {
          this.notificationToastService.error(JSON.stringify(err.error), 'Caja');
        } finally {
          this.loading = false;
        }
      });
  }

  private printCashDeskOpenCloseReport(cashDeskOpenSearchItem: CashDeskOpenSearchItem) {
    this.cashDeskService.getCashDeskOpenCloseReportPdf(cashDeskOpenSearchItem.CashDeskOpenId)
      .then((report) => {
        this.downloadLocalFileService.downLoadFile(report.ReportBase64, "Caja", "pdf");
      }).catch(err => this.notificationToastService.error(JSON.stringify(err.error), 'Caja'));
  }
}
